import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
            <div className="text-center">
                <h1 className="text-6xl font-headline font-bold text-orange mb-4">404</h1>
                <h2 className="text-2xl font-headline font-medium text-black mb-4">
                    Page Not Found
                </h2>
                <p className="text-gray-600 font-body mb-8 max-w-md">
                    Sorry, we couldn't find the build instructions you're looking for.
                </p>
                <Link
                    to="/"
                    className="inline-flex items-center px-6 py-3 bg-orange text-white font-body font-medium rounded-full hover:bg-orange/90 transition-colors"
                >
                    Back to Build Instructions
                </Link>
            </div>
        </div>
    );
};

export default NotFound;